import {Component, Input} from '@angular/core';
import {FilterParams} from "app/models/filter_form.model";
import {StatsRefs} from "app/views/referers/ref.model";
import {HelperService} from "app/lib/helper.service";
import {RefComponent} from "app/views/referers/ref.component";

@Component({
	selector: 'domain-billing-refs',
	templateUrl: './ref.component.html',
})
export class DomainBillingRefComponent {
	@Input() public refs: StatsRefs;
	@Input() public filterParams: FilterParams;
	@Input() public currentUrl: string;

	Math: any;
	
	constructor(private helper: HelperService, public refComponent: RefComponent) {
		this.Math = Math;
	}
}
